angular.module('smartorg.r6.mgmts.defineCategory', []);
require('./define-category-directive');
require('../../css/app.css');
module.exports = 'smartorg.r6.mgmts.defineCategory';
//# sourceMappingURL=app.js.map


// WEBPACK FOOTER //
// ./app/widgets/management/define-category/app/js/plumbing/app.js